import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export const usePost = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  return async <T>(path: string, body: object): Promise<T> => {
    const baseUrl = await discoveryApi.getBaseUrl('test-jwt');
    const res = await fetchApi.fetch(`${baseUrl}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      // Show the backend's error (and its cause, e.g. a 401 from the permission
      // backend) so failures are diagnosable without pod logs.
      const { message, cause } = json?.error ?? {};
      throw new Error(
        `${res.status}: ${message ?? 'Request failed'}${
          cause?.message ? ` (caused by: ${cause.message})` : ''
        }`,
      );
    }
    return json as T;
  };
};
